import { render, staticRenderFns } from "./addAlert.vue?vue&type=template&id=0d81f16e&scoped=true&"
import script from "./addAlert.vue?vue&type=script&lang=js&"
export * from "./addAlert.vue?vue&type=script&lang=js&"
import style0 from "./addAlert.vue?vue&type=style&index=0&id=0d81f16e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d81f16e",
  null
  
)

export default component.exports